const orderStrings = {
  addAddressForm: {
    formTitle: 'Add Shipping Address',
    formSubTitle: 'Enter your address details',
    formStreetFieldLabel: 'Street Name',
    formStreetFieldPlaceholder: 'eg. Salah Salem street',
    formBuildingFieldLabel: 'Building No.',
    formBuildingFieldPlaceholder: 'eg. 4th floor Apt. 12',
    formFlatFieldLabel: 'Flat No.',
    formFlatFieldPlaceholder: 'eg. 17 B',
    formLandmarkFieldLabel: 'Landmark',
    formLandmarkFieldPlaceholder: 'Eg. Behind Abou Ghaly Motors',
    formLabelFieldLabel: 'Address Label',
    addressLabelList: {
      addressLabelHomeText: 'Home',
      addressLabelWorkText: 'Work',
      addressLabelHotelText: 'Hotel',
      addressLabelOtherText: 'Other',
    },
    formSubmitBtn: 'Add Address',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
  },

  bulkOrder: {
    pageName: 'Bulk Order',
    AddPromocodeTitle: 'Enter Company Promocode',
    AddPromocodeFieldLabel: 'Company promocode',
    addPatientBtn: 'Add Patient',
    addPatientPopUpTitle: 'Add Patient',
    addPatientPopUpLabel: 'Patient Name',
    addPatientPopUpBtn: 'Add',
    editPatientPopUpBtn: 'Change',
    orderItemCountText: 'Items count',
    orderItemSearchProductPlaceholder: 'Search for your order',
    orderItemSearchProductEnvelopNoResultsText: 'No results found',
    orderItemSearchProductEnvelopOutOfStockText: 'Out of Stock',
    addOrderBulkErrorMessage: 'You must enter at least one order',
    chooseAddressNameTitle: 'Name',
    chooseAddressInfoTitle: 'Address',
    chooseAddressPhoneTitle: 'Mobile Number',
    addAddressBtn: 'Add Address',
    orderFormSubmitBtn: 'Choose Address',
    addressFormSubmitBtn: 'Add Orders',
    addressFormBackBtn: 'Back to Orders',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
    orderTotalPrice(price) {
      return `Total price: ${price} EGP`;
    },
    addOrderBulkSuccessMessage(orderCount) {
      return `${orderCount} Order${orderCount > 1 ? 's' : ''} ${
        orderCount === 1 ? 'was' : 'were'
      } added successfully`;
    },
    addOrderBulkFailMessage: 'Error happened, try again later.',
  },
};

export default orderStrings;
